var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99982 6.49995V9.83328M9.99982 13.1666H10.0081M8.84591 2.24305L1.99184 14.0819C1.61167 14.7386 1.42159 15.0669 1.44968 15.3364C1.47419 15.5714 1.59733 15.785 1.78846 15.924C2.00759 16.0833 2.38698 16.0833 3.14575 16.0833H16.8539C17.6127 16.0833 17.992 16.0833 18.2112 15.924C18.4023 15.785 18.5254 15.5714 18.55 15.3364C18.578 15.0669 18.388 14.7386 18.0078 14.0819L11.1537 2.24305C10.7749 1.58875 10.5855 1.26159 10.3384 1.15172C10.1229 1.05587 9.87678 1.05587 9.66123 1.15172C9.41413 1.26159 9.22472 1.58875 8.84591 2.24305Z",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ff6bab2e72e99b105940eb9bb4af7d09.svg";
export { ForwardRef as ReactComponent };